//#region src/olo_custom_field_key.ts
var OloCustomKeyOrderField = /* @__PURE__ */ function(OloCustomKeyOrderField) {
	OloCustomKeyOrderField["GuestPhoneNumber"] = "guestPhoneNumber";
	OloCustomKeyOrderField["GuestEmail"] = "guestEmail";
	OloCustomKeyOrderField["TableNumber"] = "tableNumber";
	OloCustomKeyOrderField["IsI9nFutureOrder"] = "isI9nFutureOrder";
	OloCustomKeyOrderField["GuestVehicleMake"] = "guestVehicle.make";
	OloCustomKeyOrderField["GuestVehicleModel"] = "guestVehicle.model";
	OloCustomKeyOrderField["GuestVehicleColor"] = "guestVehicle.color";
	OloCustomKeyOrderField["EmptyValue"] = "emptyValue";
	OloCustomKeyOrderField["TemplateString"] = "templateString";
	return OloCustomKeyOrderField;
}(OloCustomKeyOrderField || {});
//#endregion
export { OloCustomKeyOrderField };

//# sourceMappingURL=olo_custom_field_key.js.map